import { PalletRecord, ShipmentUnit, ShipmentUnitInputField, ShipmentUnitType, UoM } from "src/types";
import {
  ANIMAL_NON_CERTIFIED_SHIPMENT_MIX_ERROR_MESSAGE,
  ANIMAL_NON_CERTIFIED_SHIPMENT_VENDOR_MIX_ERROR_MESSAGE
} from "src/constants";

export const shipmentUnitTypeOptions: ShipmentUnitType[] = ["Pallets", "Boxes"];
export const shipmentUnitUoMOptions: UoM[] = ["Metric", "Imperial"];

export function isInvalidShipmentUnitType(data: unknown): boolean {
  return !shipmentUnitTypeOptions.includes(data as ShipmentUnitType);
}

export const normaliseShipmentUnitInputField = (shipmentUnitInputField: ShipmentUnitInputField): ShipmentUnit => ({
  type: shipmentUnitInputField.type as ShipmentUnitType,
  quantity: parseInt(shipmentUnitInputField.quantity) || 0,
  weight: parseFloat(shipmentUnitInputField.weight) || 0,
  length: parseFloat(shipmentUnitInputField.length) || 0,
  width: parseFloat(shipmentUnitInputField.width) || 0,
  height: parseFloat(shipmentUnitInputField.height) || 0
});

export const sortShipmentUnitsByType = (shipmentUnits: ShipmentUnit[]) =>
  shipmentUnits?.sort((a, b) => shipmentUnitTypeOptions.indexOf(a.type) - shipmentUnitTypeOptions.indexOf(b.type));

export const validateShipmentPalletComposition = (
  pallets: Pick<PalletRecord, "isAnimalNonCertified" | "vendorIds">[]
): string | undefined => {
  const animalNonCertified = pallets.filter((p) => p.isAnimalNonCertified === true);
  if (animalNonCertified.length === 0) return undefined;

  if (animalNonCertified.length !== pallets.length) {
    return ANIMAL_NON_CERTIFIED_SHIPMENT_MIX_ERROR_MESSAGE;
  }

  const vendorIds = new Set<string>();
  for (const pallet of animalNonCertified) {
    for (const id of pallet.vendorIds ?? []) {
      if (id) vendorIds.add(id);
    }
  }
  if (vendorIds.size > 1) {
    return ANIMAL_NON_CERTIFIED_SHIPMENT_VENDOR_MIX_ERROR_MESSAGE;
  }
  return undefined;
};
